import { Component, OnInit } from '@angular/core';
import { IngredientService, Ingredient } from '../../../services/ingredient.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { BaseComponent } from '../../base.component';
import { CategoryService, Category } from '../../../services/category.service';
import { NotificationsService } from "angular2-notifications";
import * as _ from 'underscore';
import { PaginationService } from 'app/services/pagination.service';

@Component({
	selector: 'app-ingredients',
	templateUrl: './ingredients.component.html',
	styleUrls: ['./ingredients.component.css']
})
export class IngredientsComponent extends BaseComponent implements OnInit {

	ingredients:any;
	categories:Category[];
	cat_assoc = {};
	q: string = '';
	inLength;
	private s;

    private allItems: Ingredient[];
	private allItemsOri: Ingredient[];
	
	cat_id: String = '';
	list: string = '';

    pager: any = {};

    pagedItems: any[];

	constructor(
		private ingredientService: IngredientService,
		private router: Router,
		private route: ActivatedRoute,
		private categoryService: CategoryService,
		private notificationsService: NotificationsService,
		private paginationService: PaginationService,
	) {
		super();
	}

	ngOnInit() {
		this.ingredients = this.ingredientService.getIngredients().subscribe(ingredients => {
			this.ingredients = ingredients.sort((a,b)=> {
				a.product_name = a.product_name || '';
				b.product_name = b.product_name || '';
				if(a.product_name == b.product_name)
				{
					return 0;
				}
				return a.product_name.toLowerCase() < b.product_name.toLowerCase() ? -1 : 1;
			})
			this.allItemsOri = _.clone(this.ingredients);
			this.allItems = _.clone(this.ingredients);
			this.setPage(1);
			this.inLength = ingredients.length;
		});

		this.categoryService.getCategories().subscribe((categories) => {
			categories = categories.filter(item => {
				return item.goes_to != 'sub'
			})
			this.categories = categories;
			categories.forEach((category, i) => {
				this.cat_assoc[category.$key] = category;
			});
		});
		this.s = this.ingredientService.s;
	}

	onDeleteClick(key) {
		var self = this;
		if(key){
			if (confirm('Are you sure?')) {
				this.ingredientService.deleteIngredient(key).then(function(){
					self.notificationsService.error('Deleted','1 product deleted');
				}).catch(function(error){
					console.log('Ada error. Error: ' + error.message);
				}) ;
			}
		}
	}

	setPage(page: number) {
		// get pager object from service
		this.pager = this.paginationService.getPager(this.allItems.length, page);

        // get current page of items
        this.pagedItems = this.allItems.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }

	filter_result() {
		if(this.q || this.cat_id || this.list) {
			this.allItems = this.allItemsOri.filter(item => {
				var regex = new RegExp( this.escapeRegExp(this.q), 'gi' );
				
				var name = regex.test(item.product_name);
				var cat  = this.cat_id ? item.category_id == this.cat_id : true;
				var li = this.list ?  item.product_list == this.list : true ;

				return name && cat && li;
			})
		}
		else
		{
			this.allItems = this.allItemsOri;
		}

		this.setPage(1);
	}

	escapeRegExp(str) {
		return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
	}
}



// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/components/ingredient/ingredients/ingredients.component.ts